export default __webpack_public_path__ + "static/media/photo--lg--93.c3c65ddb.jpg";